<div class="modal-header">
  <h5 class="modal-title">
    <i class="fa fa-edit me-2"></i>Промяна на Класификация
  </h5>
  <button type="button" class="btn-close" (click)="onCancel()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div class="mb-3">
    <p class="text-muted mb-3">
      <strong>Имейл:</strong> {{message.subject}}
    </p>
    <p class="text-muted mb-3" *ngIf="getLatestClassification() as classification">
      <strong>Текуща класификация:</strong>
      <span class="badge"
            [class.bg-success]="classification.category === EmailClassificationCategory.Zayavlenie"
            [class.bg-info]="classification.category === EmailClassificationCategory.Other"
            [class.bg-secondary]="classification.category === EmailClassificationCategory.Unknown">
        {{getClassificationLabel(classification.category)}}
      </span>
    </p>
    <p class="text-muted mb-3" *ngIf="!getLatestClassification()">
      <strong>Текуща класификация:</strong>
      <span class="badge bg-secondary">Некласифицирано</span>
    </p>
  </div>

  <div class="mb-3">
    <label for="classificationSelect" class="form-label">
      <strong>Нова класификация:</strong>
    </label>
    <select
      id="classificationSelect"
      class="form-select"
      [(ngModel)]="selectedClassification"
      [disabled]="isSaving">
      <option [ngValue]="null">-- Изберете класификация --</option>
      <option *ngFor="let option of classificationOptions" [ngValue]="option.value">
        {{option.label}}
      </option>
    </select>
  </div>

  <div class="alert alert-info" role="alert">
    <i class="fa fa-info-circle me-2"></i>
    Промяната на класификацията ще бъде отразена незабавно в списъка с имейли.
  </div>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-secondary"
    (click)="onCancel()"
    [disabled]="isSaving">
    <i class="fa fa-times me-2"></i>Отказ
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="onSave()"
    [disabled]="isSaving || selectedClassification === null">
    <i *ngIf="!isSaving" class="fa fa-save me-2"></i>
    <i *ngIf="isSaving" class="fa fa-spinner fa-spin me-2"></i>
    <span *ngIf="!isSaving">Запази</span>
    <span *ngIf="isSaving">Записване...</span>
  </button>
</div>

